function debounceNew(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class dTX_WhistList {

    constructor() {
        this.wishListData = [];

        this.LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
        this.LOCAL_STORAGE_DELIMITER = ',';
    }

    setListLocalStorageKey(LOCAL_STORAGE_WISHLIST_KEY, LOCAL_STORAGE_DELIMITER) {
        this.LOCAL_STORAGE_WISHLIST_KEY = LOCAL_STORAGE_WISHLIST_KEY;
        this.LOCAL_STORAGE_DELIMITER = LOCAL_STORAGE_DELIMITER;
    }

   
    getWishListRecords()
    {
        return this.wishListData;
    }

    getCompareListRecords()
    {
        return this.wishListData;
    }

    getProductResponse(url) {

       var responseResult = axios.get(url)
          .then((response) => {
                var text = response.data;
                text = text.replace(/^\s*[\r\n]/gm, '');
                // console.log(text); 

                return text;
           });
           
        return responseResult;
        
      
//       var responseResult =  getDTProduct(url);
      
//       alert(responseResult);

//       return responseResult;
      
    }

    getTotalCount() {
		return this.getWishlist().length;
    }
  
    getWishlist() {
        var wishlist = localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) || false;
        if (wishlist) return wishlist.split(this.LOCAL_STORAGE_DELIMITER);
        return [];
    }

    setWishlist(array) {
        var wishlist = array.join(this.LOCAL_STORAGE_DELIMITER);
        if (array.length) localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
        else localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
        return wishlist;
    }

    // Inside dTX_WhistList class in wishlist.js

// Add this inside your dTX_WhistList class or click handler
updateWishlist(handle) {
    const customerId = window.customerId; 

    if (!customerId || customerId === "") {
        window.location.href = '/account/login';
        return;
    }

    // 1. Update LocalStorage immediately so icon persists on refresh
    let wishlist = this.getWishlist();
    if (!wishlist.includes(handle)) {
        wishlist.push(handle);
        this.setWishlist(wishlist);
    }

    // 2. Toggle UI Classes
    const btn = document.querySelector(`[data-product_handle="${handle}"]`);
    if (btn) btn.classList.add('added');

    // 3. Sync with Database
    fetch('https://404coder.com/shopify-vs/nvrmind/save-wishlist.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            customer_id: customerId,
            handle_to_toggle: handle,
            shop: 'nvrmind.in'
        })
    })
    .then(res => res.json())
    .then(data => {
        // Update header count based on DB response
        const count = data.wishlist ? data.wishlist.length : wishlist.length;
        document.querySelectorAll(".dt-wishlist-cnt").forEach(c => {
            c.innerHTML = count;
            c.setAttribute('count', count);
        });
    })
    .catch(err => console.error("DB Sync Error:", err));
}

    removeWhishlist(handle) {
    var wishlist = this.getWishlist();
    wishlist = this.remove(wishlist, handle);
    var result = this.setWishlist(wishlist);
    
    // Trigger a global event so Vue knows to refresh its data
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handle: handle } }));
    
    return result;
}

    resetWishlist() {
        return this.setWishlist([]);
    }

    isAddedIntoList(handle) {
        var wishlist = this.getWishlist();  
        
        return wishlist.includes(handle);
    }

    remove(arr) {
        var what, a = arguments, L = a.length, ax;
        while (L > 1 && arr.length) {
            what = a[--L];
            while ((ax= arr.indexOf(what)) !== -1) {
                arr.splice(ax, 1);
            }
        }
        return arr;
    };
}


async function getDTProduct(url) {
    
 
    try {
      let res = await fetch(url);

      return res.text().then(function (text) {      
        return text;
      });

        
    } catch (error) {
        console.log(error);
    }
}

class dTXWhishList extends HTMLElement {
    constructor() {
      super();

      this.dTWhistList = new dTX_WhistList();

      this.debouncedOnSubmit = debounceNew((event) => {
        this.onSubmitHandler(event);
      }, 500);


      this.addWishList = this.querySelector('.add-wishlist');      

      if (this.addWishList.hasAttribute("data-product_handle")) {
      	this.productHandle = this.addWishList.getAttribute('data-product_handle');

        this.addWishList.addEventListener('click', this.debouncedOnSubmit.bind(this));

      	this.initLoad();
      }
      
      /*
      this.productHandle = this.addWishList.getAttribute('data-product_handle');

      this.addWishList.addEventListener('click', this.debouncedOnSubmit.bind(this));

      this.initLoad();
      */
    }

    onSubmitHandler(event) {
    event.preventDefault();
    event.stopPropagation();

    // Check if it's already in the wishlist
    if (this.dTWhistList.isAddedIntoList(this.productHandle)) {
        // Redirect to wishlist page instead of removing
        window.location.href = "/pages/wishlist";
    } else {
        // Add to wishlist
        this.addWishList.classList.add("adding");
        this.dTWhistList.updateWishlist(this.productHandle);
        this.postAdd();
    }
}

    postAdd() {
      /*
        document.querySelector(".dtxc-wishlist-count").setAttribute(
          'count', 
          this.dTWhistList.getTotalCount()
        );
      */  

       document.querySelector(".dt-wishlist-cnt").setAttribute(
          'count', 
          this.dTWhistList.getTotalCount()
       );

      var COUNT_WISH_LIST = this.dTWhistList.getTotalCount();
      
      var setWishListCountNew = function(COUNT_WISH_LIST) {
          if (document.querySelector('.dt-wishlist-cnt')) {

              var cnt = COUNT_WISH_LIST;

              var elementList = document.querySelectorAll(".dt-wishlist-cnt");
              elementList.forEach((element) => {
                if (cnt > 0 ) {
                    element.innerHTML = cnt;
                    //element.style.display = 'block';
                } else {
                    element.innerHTML = 0;
                   // element.style.display = 'none';
                }
             });      
          }

      };

      setWishListCountNew(COUNT_WISH_LIST);
      
        
      this.addWishList.classList.remove("adding");
      this.addWishList.classList.add("added");   
    }

    initLoad() {
    // 1. Initial UI check from LocalStorage (Instant)
    if (this.dTWhistList.isAddedIntoList(this.productHandle)) {
        this.addWishList.classList.add("added");
    } else {
        this.addWishList.classList.remove("added");
    }

    // 2. Background Sync with Database (Corrects state if removed elsewhere)
    const customerId = window.customerId;
    if (customerId && customerId !== "") {
        fetch(`https://404coder.com/shopify-vs/nvrmind/get-wishlist.php?customer_id=${customerId}&shop=nvrmind.in`)
            .then(res => res.json())
            .then(data => {
                // Ensure data is an array of handles
                let handles = Array.isArray(data) ? data : JSON.parse(data || "[]");
                
                // Update LocalStorage to match Database exactly
                this.dTWhistList.setWishlist(handles);

                // Update the heart icon state based on the fresh data
                if (handles.includes(this.productHandle)) {
                    this.addWishList.classList.add("added");
                } else {
                    this.addWishList.classList.remove("added");
                }
                
                // Update the header count while we are at it
                const count = handles.length;
                document.querySelectorAll(".dt-wishlist-cnt").forEach(c => {
                    c.innerHTML = count;
                    c.setAttribute('count', count);
                });
            })
            .catch(err => console.log("Wishlist Sync Error:", err));
    }
}
}    

customElements.define('dtx-wishlist', dTXWhishList);

function makeTimer() {

  $('.product-deal-count').each(function() {
   
    var endTime = new Date($(this).attr('data-end-time'));		
    endTime = (Date.parse(endTime) / 1000);

    var now = new Date();
    now = (Date.parse(now) / 1000);

    var timeLeft = endTime - now;
    
    if(timeLeft > 0) {
      var days = Math.floor(timeLeft / 86400); 
      var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
      var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
      var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

      if (hours < "10") { hours = "0" + hours; }
      if (minutes < "10") { minutes = "0" + minutes; }
      if (seconds < "10") { seconds = "0" + seconds; }

      $(this).find(".days").html(days + "<span>Days</span>");
      $(this).find(".hours").html(hours + "<span>Hrs</span>");
      $(this).find(".minutes").html(minutes + "<span>Mins</span>");
      $(this).find(".seconds").html(seconds + "<span>Secs</span>");	
      
    } else {
      $(this).find(".notice").html("<span>Expired</span>");
    }
    
  });

}

setInterval(function() { makeTimer(); }, 1000);
    